import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backDrop: {
      backdropFilter: 'blur(8px)',
      backgroundColor: 'rgba(0,0,30,0.4)',
      padding: 75,
    },
    logoContainer: {
      cursor: 'pointer',
      maxWidth: 200,
      margin: 'auto',
      [theme.breakpoints.down('sm')]: {
        maxWidth: 160,
        margin: 'auto',
      },
    },
    logo: {
      width: '100%',
      height: 'auto',
    },
    logoImg: {
      width: '100%',
      height: 'auto',
    },
    titleBlock: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 16,
      marginTop: 25,
      width: '100%',
      maxWidth: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    dialogTitle: {
      color: '#000a8c',
      textAlign: 'center',
      fontSize: 24,
      fontFamily: 'Poppins, sans-serif',
      fontStyle: 'normal',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: 'normal',
      '@media (max-width: 600px)': {
        fontSize: 18,
      },
    },
    dialogSubtitle: {
      color: '#000',
      textAlign: 'center',
      fontSize: 16,
      fontFamily: 'Poppins, sans-serif',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
    },
    dialogsubSubtitle: {
      color: '#23296F',
      textAlign: 'center',
      fontSize: 24,
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: 500,
      letterSpacing: '0em',
    },
    dialogContentContainer: {
      paddingLeft: 50,
      paddingRight: 50,
      paddingBottom: 30,
      '@media (max-width: 600px)': {
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 10,
      },
    },
    formContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      '@media (min-width: 1250px)': {
        maxWidth: 600,
      },
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '80%',
    },
    fieldWithLabel: {
      marginTop: 20,
      width: '100%',
    },
    errorField: {
      color: theme.palette.warning.main,
      font: 'normal normal bold 10px/14px ITC Avant Garde Gothic Std Medium',
    },
    input: {
      flex: 1,
      border: `1px solid #E3E8F0`,
      width: '100%',
      marginTop: 5,
      height: 48,
      '&:before': {
        display: 'none',
      },
      '& input': {
        fontSize: 13,
        padding: 10,
      },
    },
    inputPassword: {
      paddingRight: 5,
    },
    labelText: {
      margin: 'auto',
      font: 'normal normal bold 14px ITC Avant Garde Gothic Std Medium',
      color: '#000A8C',
    },
    btnConnectContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: 20,
      width: '100%',
    },
    btnConnect: {
      width: '80%',
      backgroundColor: '#000A8C',
      borderRadius: 3,
      opacity: 1,
      textTransform: 'none',
      color: '#fff',
    },
    forgotPasswordLink: {
      marginTop: 5,
      textAlign: 'end',
    },
    forgotPasswordLinkText: {
      color: '#000A8C',
      textDecoration: 'underline',
      font: 'normal normal bold 11px/15px ITC Avant Garde Gothic Std Medium',
    },
    passwordErrorField: {
      color: theme.palette.warning.main,
      font: 'normal normal bold 10px/14px ITC Avant Garde Gothic Std Medium',
      minHeight: 20,
      maxWidth: 330,
    },
    eyeImg: {
      cursor: 'pointer',
      zIndex: 1,
    },
    inputWitAdornment: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    paperRounded: {
      '& .MuiDialog-paper': {
        '@media (max-width: 600px)': {
          position: 'absolute',
          bottom: 0,
          margin: 0,
          width: '-webkit-fill-available',
        },
      },
      '& .MuiPaper-rounded': {
        borderRadius: 16,
        '@media (max-width: 600px)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
      },
    },
  })
);

export default useStyles;
